import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { SummaryRoutingModule } from './summary-routing.module';
import { ButtonModule } from 'src/app/shared/button/button.module';
import { TooltipButtonModule } from 'src/app/shared/tooltip-button/tooltip-button.module';
import { TranslateModule, TranslatePipe } from '@ngx-translate/core';
import { AngularSvgIconModule } from 'angular-svg-icon';
import { SummaryComponent } from 'src/app/pages/summary/summary.component';
import { PreloadSpinnerModule } from 'src/app/shared/preload-spinner/preload-spinner.module';
import { ChartsModule } from 'src/app/shared/charts/charts.module';
import { DropdownModule } from 'src/app/shared/dropdown/dropdown.module';
import { ToggleSwitchModule } from 'src/app/shared/toggle-switch/toggle-switch.module';
import { ModelStrategyCarouselModule } from 'src/app/shared/model-strategy-carousel/model-strategy-carousel.module';
import { OwnedStrategyCarouselModule } from 'src/app/shared/owned-strategy-carousel/owned-strategy-carousel.module';
import { PricePipeModule } from 'src/app/pipes/price.module';

@NgModule({
  declarations: [
    SummaryComponent,
  ],
  imports: [
    CommonModule,
    SummaryRoutingModule,
    ButtonModule,
    TooltipButtonModule,
    TranslateModule,
    AngularSvgIconModule,
    PreloadSpinnerModule,
    ChartsModule,
    DropdownModule,
    ToggleSwitchModule,
    PricePipeModule,
    ModelStrategyCarouselModule,
    OwnedStrategyCarouselModule,
  ],
  providers: [
    TranslatePipe,
  ]
})
export class SummaryModule { }
